/**
 * @typedef {Object} BreadcrumbItem
 * @property {string} name -パンくずに表示されるタイトル
 * @property {string} url - パンくずのページURL
 */

/**
 *
 * @param {string} title ページタイトル
 * @param {string} description ページデスクリプション
 * @param {BreadcrumbItem[]} breadCrumb パンくずリスト
 *
 */

export function useCustomJsonld(breadCrumb) {
  const config = useRuntimeConfig()

  useJsonld(() => (
    [{
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': [
        {
          '@type': 'ListItem',
          'position': 1,
          'item': {
            '@id': `${config.public.hostDomain}`,
            'name': 'トップ'
          }
        },
        ...breadCrumb.map((item, index) => {
          return {
            '@type': 'ListItem',
            'position': index + 2,
            'item': {
              ...(item.link ? { '@id': new URL(`${config.public.hostDomain}${item.link}`) } : {}),
              name: item.text
            }
          }
        })
      ]
    }
    ]
  ))
}
